// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Stepper_wrap__26mCn","numberStyle":"Stepper_numberStyle__1x56l","current":"Stepper_current__2xjlB"};